import _ from 'lodash';
import { computed } from 'mobx';

import { BaasicDropdownStore } from 'core/stores';

class DxCodeDropdownStore extends BaasicDropdownStore {
    constructor(options, actions, initialState) {
        // Forward (options, actions, initialState) to BaasicDropdownStore.
        // The auto-generated `super()` from the mobx-undecorate codemod
        // dropped them, so the configured `textField: "code"` and the
        // `fetchFunc` never made it into the store — every diagnosis-code
        // dropdown in the new-flow clinical edit + intake-modal rendered
        // empty/wrong-field text. BaasicDropdownStore signature is
        // `(options = null, actions = null, initialState = null)`.
        super(options, actions, initialState);

        // MobX 6 forbids re-annotating a field a parent already annotated.
        // BaasicDropdownStore annotates `items: computed`; using `computed`
        // again here throws "Re-annotating fields is not allowed" and
        // aborts the constructor, so the store never initializes. Use
        // `override` instead (same pattern as NikoDxCodeDropdownStore).
    }

    @computed
    get items() {
        if (!this.filterTerm && _.isObject(this.value) && !_.isArray(this.value)) {
            return [this.value];
        }

        const items = this.filteredItems.length > 0 ? this.filteredItems : this.originalItems;
        if (_.isString(this.value)) {
            return items.slice();
        }
        if (_.isArray(this.value)) {
            return [
                ...items,
                ..._.map(this.value, v => ({ ...v, hideInDropdown: true }))
            ];
        }
        if (_.isObject(this.value)) {
            return [
                ...items,
                { ...this.value, hideInDropdown: true }
            ];
        }
        return items.slice();
    }
}

export default DxCodeDropdownStore;
